import React, { useContext, useEffect, useRef } from "react";
import styles from "./styles/AddNotaryPopup.module.css";
import { UserData } from "../../../Context/DataContext";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import fr_phone_countries from "react-phone-input-2/lang/fr.json";
import { GenerateID, RandomId } from "../../../Utils/RandomId";
import { floatMessage } from "../../../Utils/floatMessage";
import parse from "html-react-parser";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import useWindowDimensions from "../../Footer/footer";

function AddNotaryPopUp({ onClose }) {
  const [showTopShadow, setShowTopShadow] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  const { width } = useWindowDimensions();

  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AddNotaryPopup.AddNotaryPopup
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.AddNotaryPopup.AddNotaryPopup);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const divElementRef = useRef(null);

  useEffect(() => {
    const divElement = divElementRef.current;

    const handleScroll = () => {
      const scrollTop = divElement.scrollTop;
      const scrollHeight = divElement.scrollHeight;
      const clientHeight = divElement.clientHeight;
      setShowTopShadow(scrollTop > 0);
      setShowBottomShadow(scrollTop + clientHeight < scrollHeight - 10);
    };

    // Call handleScroll once on initial load to set shadows
    handleScroll();

    divElement.addEventListener("scroll", handleScroll);

    return () => {
      divElement.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const userData = UserData();
  const customer_id = userData?.UserData?.user_id;
  const index_ = userData?.UserData?.beneficiaries.map((beneficiary) => {
    return beneficiary.user_id;
  });
  const [modal, setModal] = useState();
  const [notary, setNotary] = useState({
    user_id: GenerateID(customer_id, "L", index_),
    name: "",
    email: "",
    phone_number: "",
    address: "",
    additional_information: "",
    notify: "",
    type: "",
  });

  const [error, setError] = useState({
    name: "",
    email: "",
    phone_number: "",
    type: "",
  });

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  // textarea
  const maxMessageLength = 10000; // Define the maximum character length for the message field

  const handleChangeDescription = () => {
    const textArea = document.getElementById("textarea");
    textArea.style.height = "0";
    const height = textArea.scrollHeight;
    textArea.style.height = `${height}px`;
  };

  const validateData = () => {
    var errors_ = {};
    var isError = false;
    if (!isValidEmail(notary.email)) {
      errors_["email"] = dublicatedcontent?.dublicatedText47;
      isError = true;
    }
    if (notary.email === "") {
      errors_["email"] = content?.addNotaryPopupError2;
      isError = true;
    }
    if (notary.name === "") {
      errors_["name"] = content?.addNotaryPopupError3;
      isError = true;
    }
    if (notary.phone_number.length < 5) {
      errors_["phone_number"] = content?.addNotaryPopupError4;
      isError = true;
    }
    if (notary.type === "") {
      errors_["type"] = content?.addNotaryPopupError5;
      isError = true;
    }
    setError(errors_);
    setTimeout(() => {
      setError({
        name: "",
        email: "",
        phone_number: "",
        type: "",
      });
    }, 5000);
    return isError;
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (validateData()) {
      return;
    }
    // When the notary is created, a trustee needs to be created automatically
    const trustee_index = userData?.UserData?.trustees.map((trustee) => {
      return trustee.user_id;
    });
    const trustee = {
      user_id: GenerateID(customer_id, "T", trustee_index),
      name: notary?.name,
      additional_information: notary?.additional_information,
      email: notary?.email,
      phone_number: notary?.phone_number,
      awareness_status: false,
      assets: [],
      beneficiaries: [],
    };
    userData.setUserData({
      ...userData.UserData,
      trustees: [...userData?.UserData.trustees, trustee],
      legal: [{ ...notary, associated_trustee: trustee?.user_id }],
    });

    userData.Update(RandomId(10));
    floatMessage(dublicatedcontent?.saved);
    onClose();
  };

  const editNotary = (key, value) => {
    try {
      setNotary({ ...notary, [key]: value });
    } catch (e) {
      console.log(e);
    }
  };

  const trimNameField = (value) => {
    const name = value.trim();
    editNotary("name", name);
  };

  useEffect(() => {}, [notary]);
  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = "unset";
    };
  }, []);

  return (
    <div className={styles.background}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={
          width <= 599
            ? {
                height: window.innerHeight - 10,
              }
            : {}
        }
        className={styles.main_box}
      >
        <div onClick={onClose} className={styles.close_logo}></div>
        <div className={styles.title}>{content.addNotaryPopupTitle1}</div>
        <div
          className={styles.popup_scrollable}
          id="scrollContainer"
          ref={divElementRef}
        >
          <div
            className={`${styles.shadow_top} ${
              showTopShadow ? styles.active : ""
            }`}
          />

          {/* <InfoTitle message={"Lorem ipsum text ..."} title={dublicatedcontent.dublicatedText2} /> */}
          <div className={styles.large_text}>
            {parse(content.addNotaryPopupText2)}
          </div>

          <div className={styles.center}>
            <div className={styles.field_wrap}>
              <div className={styles.field}>
                <div
                  className={`${styles.input_title} ${styles.required_field}`}
                >
                  {content.addNotaryPopupText3}
                </div>
                <select
                  defaultValue={String(notary.type)}
                  onChange={(e) => editNotary("type", e.target.value)}
                  className={`${styles.select} ${
                    notary.type.length ? styles.select_filled : ""
                  } ${error.type ? styles.field_error : ""}`}
                >
                  <option value="" hidden>
                    {content.addNotaryPopupText4}
                  </option>
                  <option value="Notary">{content.addNotaryPopupText5}</option>
                  <option value="Lawyer">{content.addNotaryPopupText6}</option>
                  <option value="Wealth Manager">
                    {content.addNotaryPopupText22}
                  </option>
                </select>
                <div className={styles.error_message}>
                  {error.type ? error.type : null}
                </div>
              </div>
            </div>

            <div className={styles.field_wrap}>
              <div className={styles.field}>
                <div
                  className={`${styles.input_title} ${styles.required_field}`}
                >
                  {content.addNotaryPopupText7}
                </div>
                <input
                  onBlur={(e) => trimNameField(e.target.value)}
                  onChange={(e) => editNotary("name", e.target.value)}
                  value={notary.name}
                  className={`${styles.beneficiary_input} ${
                    error.name ? styles.field_error : ""
                  }`}
                  placeholder={content.addNotaryPopupText8}
                ></input>

                <div className={styles.error_message}>
                  {error.name ? error.name : null}
                </div>
              </div>

              <div className={styles.field}>
                <div
                  className={`${styles.input_title} ${styles.required_field}`}
                >
                  {content.addNotaryPopupText9}
                </div>
                <div
                  className={`${styles.phone_div} ${
                    error.phone_number ? styles.phone_div_error : ""
                  }`}
                >
                  <PhoneInput
                    countryCodeEditable={false}
                    localization={
                      websiteCurrentLang?.label === "fr"
                        ? fr_phone_countries
                        : undefined
                    }
                    country={websiteCurrentLang?.label === "fr" ? "fr" : "us"}
                    placeholder={content.addNotaryPopupText10}
                    onChange={(e, countryData) => {
                      editNotary("phone_number", e);
                    }}
                  />
                </div>
                <div className={styles.error_message}>
                  {error.phone_number ? error.phone_number : null}
                </div>
              </div>
            </div>

            <div className={styles.field_wrap}>
              <div className={styles.field}>
                <div
                  className={`${styles.input_title} ${styles.required_field}`}
                >
                  {content.addNotaryPopupText11}
                </div>
                <input
                  value={notary.email}
                  onChange={(e) =>
                    editNotary("email", e.target.value.toLowerCase())
                  }
                  className={`${styles.beneficiary_input} ${
                    error.email ? styles.field_error : ""
                  }`}
                  placeholder={content.addNotaryPopupText11}
                ></input>
                <div className={styles.error_message}>
                  {error.email ? error.email : null}
                </div>
              </div>

              <div className={styles.field}>
                <div className={styles.input_title}>
                  {content.addNotaryPopupText13}
                </div>
                <input
                  onChange={(e) => editNotary("address", e.target.value)}
                  className={styles.beneficiary_input}
                  placeholder={content?.addNotaryPopupText13}
                ></input>
              </div>
            </div>

            <div className={styles.message_field}>
              <div className={styles.input_title}>
                {content.addNotaryPopupText16}
              </div>
              <textarea
                style={{
                  height: "max-content !important",
                }}
                id="textarea"
                placeholder={content.addNotaryPopupText16}
                maxLength={maxMessageLength}
                onChange={(e) => {
                  editNotary("additional_information", e.target.value);
                  handleChangeDescription(e);
                }}
                className={styles.large_message}
              ></textarea>
              <div
                className={`${styles.file_counter} ${
                  notary.additional_information.length === maxMessageLength
                    ? styles.error_text
                    : ""
                }`}
              >
                {notary.additional_information.length === maxMessageLength ? (
                  <>{content.addNotaryPopupText17}</>
                ) : (
                  ""
                )}
                {notary.additional_information.length}/{maxMessageLength}{" "}
                {content.addNotaryPopupText21}
              </div>
            </div>
            {/* <div>
              <h2>upload image</h2>
              <div
                style={{
                  width: "100%",
                  height: "100px",
                }}
              >
                <ImgCrop maxZoom={5} zoomOnWheel={true}>
                  <Upload
                    maxCount={1}
                    action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
                    listType="picture-card"
                  >
                    upload
                  </Upload>
                </ImgCrop>
              </div>
            </div> */}
          </div>

          <div
            className={`${styles.shadow_bottom} ${
              showBottomShadow ? styles.active : ""
            }`}
          />

          {modal ? (
            <div style={{ position: "relative", zIndex: "6" }}>{modal}</div>
          ) : null}
        </div>

        <div className={styles.actions_toolbar}>
          <div onClick={() => onClose()} className={styles.cancel_button}>
            {content.addNotaryPopupText18}
          </div>
          <div onClick={(e) => handleSave(e)} className={styles.save_button}>
            {content.addNotaryPopupText19}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddNotaryPopUp;
